import AddIcon from '@mui/icons-material/Add'
import { Box, Button, Stack } from '@mui/material'
import { useCallback, useContext, useMemo } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { CounterSalesContext } from '../../../providers/CounterSalesProvider/CounterSalesProvider'
import { useCreateCounterSaleMutation } from '../../../redux/api'
import { CounterSaleInfoStatusEnum } from '../../../sdk'
import { NONE_ID } from '../../../utils/convertEmptyStringToUndefined/convertEmptyStringToUndefined'
import { CannedJobPartsDialogUI } from '../../CannedJobs/PartsDialogUI/CannedJobPartsDialogUI'
import { useAddCustomPartsDialog } from '../../CannedJobs/useAddCustomPartsDialog/useAddCustomPartsDialog'
import { Tabs } from '../../Tabs'
import CounterSaleInventoryStore from './CounterSaleInventoryStore'
import CounterSaleProductStore from './CounterSaleProductStore'

const CounterSaleStore = () => {
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const { activeCounterSale } = useContext(CounterSalesContext)
  const [createCounterSale, { isLoading }] = useCreateCounterSaleMutation()

  const { setCustomProps: setAddCustomPartsProps, customPartsDialogProps } =
    useAddCustomPartsDialog({
      submitCallback: undefined,
      cannedJobId: undefined,
      counterSaleId: activeCounterSale?.entry?.id
    })

  const addCustomPart = useCallback(async () => {
    if (!activeCounterSale) {
      const newSale = await createCounterSale({
        authorization: accessToken,
        counterSaleInfo: {
          shop: shopId,
          status: CounterSaleInfoStatusEnum.InProgress
        }
      })
      if ('data' in newSale) {
        setAddCustomPartsProps({
          existingEntry: undefined
        })
      }
    } else {
      setAddCustomPartsProps({
        existingEntry: undefined
      })
    }
  }, [
    accessToken,
    activeCounterSale,
    createCounterSale,
    setAddCustomPartsProps,
    shopId
  ])

  const tabTitles = ['Inventory', 'Product']
  const tabItems = useMemo(() => {
    return [
      <Box key="Inventory" paddingTop={2}>
        <CounterSaleInventoryStore />
      </Box>,
      <Box key="Product" paddingTop={2}>
        <CounterSaleProductStore />
      </Box>
    ]
  }, [])

  return (
    <>
      {customPartsDialogProps && (
        <CannedJobPartsDialogUI
          {...customPartsDialogProps}
          defaultPartsMatrixId={NONE_ID}
        />
      )}
      <Tabs
        tabTitles={tabTitles}
        tabItems={tabItems}
        testId="counter-sale-tabs"
        itemsRight={
          <Stack direction="row" alignItems="center" spacing={2}>
            <Button
              onClick={addCustomPart}
              disabled={isLoading}
              fullWidth
              variant="contained"
              startIcon={<AddIcon />}>
              Custom Product
            </Button>
          </Stack>
        }
      />
    </>
  )
}

export default CounterSaleStore
